
import { Component, Vue } from 'vue-property-decorator';
import { NavBar, Tab } from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { TransactionsTable } from '@/modules/transaction/views/TransactionsLegacy/components/TransactionsTable';
import { TransactionModal } from '@/modules/transaction/views/TransactionsLegacy/components/TransactionModal';
import { WarrenModules } from '@/types/navigation';
import { Menu } from '@/modules/transaction/views/TransactionsLegacy/helpers/navigation';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { OpenTransactionEventPayload } from '@/modules/transaction/views/TransactionsLegacy/types';
import {
  trackPageLoad,
  trackPageBackClick
} from '@/modules/transaction/views/TransactionsLegacy/helpers/track-events';
import { trackTransactionDetails } from '@/modules/transaction/views/TransactionsLegacy/helpers/transactions-events';

@Component({
  components: {
    NavBar,
    Tab,
    BackButton,
    TransactionModal,
    TransactionsTable
  }
})
export default class TransactionsView extends Vue {
  private transactionId = '';
  private transactionType = '';
  private menu: Menu = {
    module: WarrenModules.Wealth,
    label: 'Carteiras',
    feature: FeatureFlags.WEALTH_3_0
  };

  private showModal = false;
  private module: WarrenModules = WarrenModules.Wealth;
  reloadTable = false;

  created() {
    trackPageLoad();
  }

  private openOrderModal(transaction: OpenTransactionEventPayload) {
    this.transactionType = transaction.typeV2 || transaction.type;
    this.transactionId = transaction.id;
    this.showModal = true;

    trackTransactionDetails(this.module, transaction.type);
  }

  private closeOrderModal() {
    this.transactionId = '';
    this.showModal = false;
    this.reloadTable = !this.reloadTable;
  }

  private onBackClick() {
    this.$router.back();
    trackPageBackClick();
  }
}
